module.exports = __webpack_public_path__ + "static/media/d5.11c0dda9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/marmalade/d5.png
// module id = 278
// module chunks = 0